'use client';

import { AlertTriangle } from 'lucide-react';

interface UnsavedChangesDialogProps {
  isOpen: boolean;
  onSave: () => void;
  onDiscard: () => void;
  onCancel: () => void;
}

export function UnsavedChangesDialog({ isOpen, onSave, onDiscard, onCancel }: UnsavedChangesDialogProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onCancel}
      />

      {/* Dialog */}
      <div className="relative bg-bg-card border border-border rounded-xl shadow-2xl w-full max-w-md mx-4 animate-in fade-in zoom-in-95 duration-200">
        <div className="p-6">
          {/* Icon */}
          <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-yellow-500/10 flex items-center justify-center">
            <AlertTriangle className="w-6 h-6 text-yellow-500" />
          </div>

          {/* Title */}
          <h3 className="text-lg font-semibold text-text text-center mb-2">
            Unsaved Changes
          </h3>

          {/* Description */}
          <p className="text-sm text-text-secondary text-center mb-6">
            You have unsaved annotations. Would you like to save them before leaving?
          </p>

          {/* Actions */}
          <div className="flex flex-col gap-2">
            <button
              onClick={onSave}
              className="w-full py-2 px-4 bg-primary text-white font-medium rounded-lg hover:bg-primary-hover transition-colors"
            >
              Save & Leave
            </button>
            <button
              onClick={onDiscard}
              className="w-full py-2 px-4 bg-bg-alt text-text-secondary font-medium rounded-lg hover:bg-bg-alt/80 hover:text-text transition-colors"
            >
              Discard Changes
            </button>
            <button
              onClick={onCancel}
              className="w-full py-2 px-4 text-text-muted font-medium rounded-lg hover:text-text-secondary transition-colors"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
